import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import API from '@/lib/API';
import { AttachmentType } from '@/types';

@Module
export default class Attachments extends VuexModule {
  data: {} = {};

  get attachmentsDetails() {
    return this.data;
  }

  @Action({ rawError: true })
  async updateAttachmentType({ attachment, type }: { attachment: number; type: AttachmentType }) {
    console.log('actions:updateType'); // eslint-disable-line no-console

    const result = await API.updateAttachmentType(attachment, type);

    if (result instanceof Error) {
      return Promise.reject(result);
    }

    return result;
  }

  @Mutation
  setAttachmentsDetails({ attachmentsDetails }: { attachmentsDetails: {} }) {
    console.log('mutations:setAttachmentsDetails'); // eslint-disable-line no-console

    this.data = attachmentsDetails;

    return Promise.resolve();
  }

  @Action({ rawError: true })
  async initAttachmentsDetails() {
    console.log('actions:initAttachmentsDetails'); // eslint-disable-line no-console

    return this.context.dispatch('updateAttachmentsDetails');
  }

  @Action({ rawError: true })
  async updateAttachmentsDetails() {
    console.log('store/attachments - actions:updateAttachmentsDetails'); // eslint-disable-line no-console

    const attachmentsDetails = await API.getAttachmentsDetails();

    if (attachmentsDetails instanceof Error) return Promise.reject(attachmentsDetails);

    return this.context.commit('setAttachmentsDetails', { attachmentsDetails });
  }
}
